import { LitEntity, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import './request-removal-modal';

class RequestRemovalButton extends LitEntity {
  static get properties() {
    return {
      showModal: { type: Boolean, attribute: false },
      hideWhenUnavailable: { type: Boolean, attribute: 'hide-when-unavailable' },
      fullWidth: { type: Boolean, attribute: 'full-width', reflect: true },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host([full-width]) {
        width: 100%;
      }
    `];
  }

  render() {
    const canRemove = this.entity?.hasAction('generate-removal-request');
    if (!canRemove && this.hideWhenUnavailable) {
      return html``;
    }
    return html`
      <button class="button button--contained" @click="${this._onClick}" ?disabled="${!canRemove}" ?full-width="${this.fullWidth}">Request Removal</button>
      <request-removal-modal
        .href="${this.href}"
        ?hide="${!this.showModal}"
        @close="${() => this.showModal = false}"
        @response="${({ detail }) => this.dispatchEvent(new CustomEvent('response', { detail, bubbles: true, composed: true }))}"
      ></request-removal-modal>
    `;
  }

  _onClick(e) {
    e.stopPropagation();
    this.showModal = true;
  }
}

window.customElements.define('request-removal-button', RequestRemovalButton);
